import { useCallback, useState } from 'react';

import { captureException } from '../../../logger/Logger';
import { useVisitorId } from '../../../user/providers/VisitorProvider';
import { startForgotPassword } from '../../api/AuthApi';
import { ResetPasswordSource } from '../../types/Auth';

/** Shared duplicate_email reaction, used by every account-creation form. */
export const useReturningMemberPasswordReset = () => {
    const [
        hasTriggeredReturningMemberPasswordReset,
        setHasTriggeredReturningMemberPasswordReset,
    ] = useState(false);
    const [hasMatchedActiveAccount, setHasMatchedActiveAccount] =
        useState(false);
    const [hasEncounteredError, setHasEncounteredError] = useState(false);
    const visitorId = useVisitorId();

    const handleDuplicateEmail = useCallback(
        async (email: string) => {
            try {
                const { isActiveMember } = await startForgotPassword({
                    email,
                    source: ResetPasswordSource.RETURNING_MEMBER,
                    visitorId,
                });
                // Active accounts don't get a reset email.
                if (isActiveMember) {
                    setHasMatchedActiveAccount(true);
                } else {
                    setHasTriggeredReturningMemberPasswordReset(true);
                }
            } catch (err) {
                captureException(err);
                setHasEncounteredError(true);
            }
        },
        [visitorId],
    );

    return {
        hasTriggeredReturningMemberPasswordReset,
        hasMatchedActiveAccount,
        hasEncounteredError,
        handleDuplicateEmail,
    };
};
